import React from "react";

const PageTitle = ({
  title,
  action,
  actionName,
  btn2,
  action2,
  actionName2,
  rightElement,
}) => {
  return (
    <div className="page-header">
      <div>
        <h1 className="page-title">{title}</h1>
      </div>
      {rightElement ? (
        <div>{rightElement}</div>
      ) : (
        <div style={{ display: "flex" }} className="onboarding-btns">
          {action && (
            <div className="ml-auto pageheader-btn pageheader-btn-left">
              <a
                className="btn btn-secondary btn-icon text-white mr-2 onboarding-btn"
                onClick={action}
              >
                <span></span>
                {actionName}
              </a>
            </div>
          )}
          {btn2 && (
            <div className="ml-auto pageheader-btn">
              <a
                className="btn btn-primary btn-icon text-white mr-2 ml-2 onboarding-btn"
                onClick={action2}
              >
                <span></span>
                {actionName2}
              </a>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default PageTitle;
